var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-form',{attrs:{"title":_vm.$t('label.newUser'),"validations":_vm.validations},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }